/** A message instead of a task: an error, a wait, a confirmation. `loading` shows a pulsing placeholder. */
import { z } from 'zod';
import { defineWidget } from '../contract';
import { intentSchema, run } from '../intent';
import { Button } from '../../ui-kit/Button';
import { Icon } from '../../ui-kit/Icon';
import css from '../Widgets.module.css';

const schema = z.object({
  tone: z.enum(['info', 'ok', 'error', 'loading']).default('info'),
  icon: z.string().optional(),
  title: z.string(),
  text: z.string().optional(),
  action: z.object({ label: z.string(), intent: intentSchema }).optional(),
});

const ICON = { info: 'info', ok: 'done', error: 'warning', loading: 'loading' } as const;

export const message = defineWidget({
  key: 'message',
  schema,
  Component: ({ props, api }) => (
    <div className={`${css.message} ${css[props.tone]}`} role={props.tone === 'error' ? 'alert' : 'status'}>
      <span className={props.tone === 'loading' ? css.spin : undefined}><Icon name={props.icon ?? ICON[props.tone]} size={88} /></span>
      <h2>{props.title}</h2>
      {props.text && <p>{props.text}</p>}
      {props.tone === 'loading' && <div className={css.skeletons}><i /><i /><i /></div>}
      {props.action && (
        <Button tone="primary" size="lg" onClick={() => run(api, props.action!.intent)}>{props.action.label}</Button>
      )}
    </div>
  ),
});
